import React, { createContext, useEffect, useState } from 'react'
import axios from 'axios'

export const MasterRefContext = createContext("")

const MasterRefProvider = ({children}) => {
    const [masterRef, setMasterRef] = useState(process.env.GATSBY_PRISMIC_DEFAULT_MASTER_REF)

    const fetchMasterRef = () => {
        const prismicRepoURL = `https://${process.env.GATSBY_PRISMIC_REPOSITORY_NAME}.cdn.prismic.io/api/v2`
        
        axios.get(prismicRepoURL)
            .then(res => {
                if (res.status !== 200 || !res.data) {
                    console.error(res)
                    setMasterRef("ERROR")
            } else {
                // console.log(res.data.refs[0].ref)
                setMasterRef(res.data.refs[0].ref)
                }
            })
    }
        
    useEffect(() => {
        fetchMasterRef() 
    },[])

    return (
        <MasterRefContext.Provider value={masterRef}>
            {children}
        </MasterRefContext.Provider>
    )
}

export default MasterRefContext
export { MasterRefProvider }